import { Document } from '@contentful/rich-text-types'
import {
  SideBySideResponsive,
  SideBySideResponsiveProps,
} from '@awazevr/design-system.components.side-by-side-responsive'
import {
  ResponsiveImage,
  ResponsiveImageProps,
} from '@/components/ResponsiveImage'
import RichText from '@/components/RichText/RichText'

export interface SideBySideModuleProps
  extends Omit<Omit<SideBySideResponsiveProps, 'image'>, 'text'> {
  image: ResponsiveImageProps
  textColor?: 'light' | 'dark'
  text?: Document
  heroSection?: boolean
}

export const SideBySideModule: React.FC<SideBySideModuleProps> = ({
  image,
  textColor,
  text,
  heroSection,
  ...props
}) => {
  // 90% of the side-by-side modules are used as a hero section.
  // If the value in Contentful is undefined, it means that it should NOT be lazy-loaded.
  const lazyLoadingDisable = heroSection !== false

  return (
    <SideBySideResponsive
      {...props}
      text={
        text && (
          <RichText
            content={text}
            textColor={
              textColor === 'light'
                ? 'ColorTextBodyOnDark'
                : 'ColorTextBodyOnWhite'
            }
          />
        )
      }
      image={<ResponsiveImage {...image} lazyLoading={!lazyLoadingDisable} />}
    />
  )
}
